import './wdyr';

import { Admin } from 'react-admin';
import i18nProvider from './components/languages/index';
import Home from './components/home/index';
import * as constants from './constants';
import * as Reducers from './configuration/reducers';
import Routes from './configuration/routes';
import Layout from './components/layouts/Layout';
import authProvider from './components/authentication/reducer';
import Login from './components/authentication/loadable-login';
import { useTranslate } from 'react-admin';
import dataProvider from './dataProvider';
import { CookiesProvider } from 'react-cookie';
import InitialComponent from './configuration/InitialComponent';
import sagas from './configuration/sagas';
import { SnackbarProvider } from 'notistack';

const initialComponentPermission = [
    constants.PERMISSION_ACTIONS.GET_USER,
    constants.PERMISSION_ACTIONS.GET_IAM_POLICIES,
    constants.PERMISSION_ACTIONS.GET_LOGOUT,
]

export default function App() {
    const translate = useTranslate();
    return (
        <SnackbarProvider
            maxSnack={6}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
        >
            <CookiesProvider>
                <Admin
                    dataProvider={dataProvider}
                    title={translate('main.title')}
                    dashboard={Home}
                    i18nProvider={i18nProvider}
                    customReducers={Reducers}
                    locale={constants.configuration.DEFAULT_LANGUAGE}
                    customRoutes={Routes}
                    layout={Layout}
                    authProvider={authProvider}
                    loginPage={Login}
                    customSagas={sagas}
                >
                    {(permissions: any) => {
                        return ([
                            initialComponentPermission.filter(permission => permissions.ALLOWED.includes(permission)).length > 0
                                ? <InitialComponent />
                                : null,
                        ])
                    }}
                </Admin>
            </CookiesProvider>
        </SnackbarProvider>
    );
}
